"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var useI18n_1 = __importDefault(require("@paprika/l10n/lib/useI18n"));
var tokens_1 = __importDefault(require("@paprika/tokens"));
var sc = __importStar(require("./SkipButton.styles"));
function SkipButton(_a) {
    var mainContentSelector = _a.mainContentSelector;
    var i18n = useI18n_1.default();
    function handleClickSkipToMain() {
        var mainElement = document.querySelector(mainContentSelector);
        mainElement.tabIndex = -1;
        mainElement.focus({ preventScroll: true });
        window.scrollTo({
            top: mainElement.getBoundingClientRect().top + document.documentElement.scrollTop,
            behavior: 'smooth',
        });
    }
    return (react_1.default.createElement(sc.SkipButtonWrapper, { "data-sri-anchor": "global-navigation.skip-main", onClick: handleClickSkipToMain },
        react_1.default.createElement(sc.SkipLabel, { "data-sri-anchor": "global-navigation.skip-label" },
            i18n.t('global_navigation.skip_button'),
            react_1.default.createElement(sc.ArrowRightIconStyled, { "data-sri-anchor": "skip-main.icon", color: tokens_1.default.color.white, size: 14 }))));
}
SkipButton.propTypes = {
    mainContentSelector: prop_types_1.default.string.isRequired,
};
exports.default = SkipButton;
//# sourceMappingURL=SkipButton.js.map